import _get from "./get";

const userFeedbackManager = {
  _get,
};

export default userFeedbackManager;
